import suigarLogoMixedSvg from '@/assets/logo/suigar-logo-mixed.svg';
import defaultLogoFullPng from '@/assets/logo/suigar-logo-full.png';
import defaultLogoFullSvg from '@/assets/logo/suigar-logo-full.svg';
import defaultIconSvg from '@/assets/icon/suigar-icon.svg';
import defaultIconLightSvg from '@/assets/icon/suigar-icon-white.svg';
import defaultIconRoundedSvg from '@/assets/icon/suigar-icon-rounded.svg';
import defaultIconRoundedPng from '@/assets/icon/suigar-icon-rounded.png';
import defaultCapyTop from '@/assets/suifrens/capy-top.png';
import defaultCapyTopSurprised from '@/assets/suifrens/capy-top-surprised.png';
import defaultSideCapy from '@/assets/suifrens/side-capy.svg';
import defaultSideBullshark from '@/assets/suifrens/side-bullshark.svg';

// Saint Patrick
import spIcon from '@/assets/events/saint-patrick/icon.svg';
import spIconLight from '@/assets/events/saint-patrick/icon-light.svg';
import spIconRounded from '@/assets/events/saint-patrick/icon-rounded.svg';
import spIconRoundedPng from '@/assets/events/saint-patrick/icon-rounded.png';
import spLogoFullSvg from '@/assets/events/saint-patrick/logo-full.svg';
import spLogoFullPng from '@/assets/events/saint-patrick/logo-full.png';
import spCapyTop from '@/assets/events/saint-patrick/suifrens/capy-top.png';
import spCapyTopSurprised from '@/assets/events/saint-patrick/suifrens/capy-top-surprised.png';
import spSideCapy from '@/assets/events/saint-patrick/suifrens/side-capy.svg';
import spSideBullshark from '@/assets/events/saint-patrick/suifrens/side-bullshark.svg';

// Valentines
import valIcon from '@/assets/events/valentines/icon.svg';
import valIconLight from '@/assets/events/valentines/icon-light.svg';
import valIconRounded from '@/assets/events/valentines/icon-rounded.svg';
import valIconRoundedPng from '@/assets/events/valentines/icon-rounded.png';
import valLogoFullSvg from '@/assets/events/valentines/logo-full.svg';
import valLogoFullPng from '@/assets/events/valentines/logo-full.png';
import valCapyTop from '@/assets/events/valentines/suifrens/capy-top.png';
import valCapyTopSurprised from '@/assets/events/valentines/suifrens/capy-top-surprised.png';
import valSideCapy from '@/assets/events/valentines/suifrens/side-capy.svg';
import valSideBullshark from '@/assets/events/valentines/suifrens/side-bullshark.svg';

// Easter
import easterIcon from '@/assets/events/easter/icon.svg';
import easterIconLight from '@/assets/events/easter/icon-light.svg';
import easterIconRounded from '@/assets/events/easter/icon-rounded.svg';
import easterIconRoundedPng from '@/assets/events/easter/icon-rounded.png';
import easterLogoFullSvg from '@/assets/events/easter/logo-full.svg';
import easterLogoFullPng from '@/assets/events/easter/logo-full.png';
import easterCapyTop from '@/assets/events/easter/suifrens/capy-top.png';
import easterCapyTopSurprised from '@/assets/events/easter/suifrens/capy-top-surprised.png';
import easterSideCapy from '@/assets/events/easter/suifrens/side-capy.svg';
import easterSideBullshark from '@/assets/events/easter/suifrens/side-bullshark.svg';

// Summer
import summerIcon from '@/assets/events/summer/icon.svg';
import summerIconLight from '@/assets/events/summer/icon-light.svg';
import summerIconRounded from '@/assets/events/summer/icon-rounded.svg';
import summerIconRoundedPng from '@/assets/events/summer/icon-rounded.png';
import summerLogoFullSvg from '@/assets/events/summer/logo-full.svg';
import summerLogoFullPng from '@/assets/events/summer/logo-full.png';
import summerCapyTop from '@/assets/events/summer/suifrens/capy-top.png';
import summerCapyTopSurprised from '@/assets/events/summer/suifrens/capy-top-surprised.png';
import summerSideCapy from '@/assets/events/summer/suifrens/side-capy.svg';
import summerSideBullshark from '@/assets/events/summer/suifrens/side-bullshark.svg';

// Halloween
import halloweenIcon from '@/assets/events/halloween/icon.svg';
import halloweenIconLight from '@/assets/events/halloween/icon-light.svg';
import halloweenIconRounded from '@/assets/events/halloween/icon-rounded.svg';
import halloweenIconRoundedPng from '@/assets/events/halloween/icon-rounded.png';
import halloweenLogoFullSvg from '@/assets/events/halloween/logo-full.svg';
import halloweenLogoFullPng from '@/assets/events/halloween/logo-full.png';
import halloweenCapyTop from '@/assets/events/halloween/suifrens/capy-top.png';
import halloweenCapyTopSurprised from '@/assets/events/halloween/suifrens/capy-top-surprised.png';
import halloweenSideCapy from '@/assets/events/halloween/suifrens/side-capy.svg';
import halloweenSideBullshark from '@/assets/events/halloween/suifrens/side-bullshark.svg';

// Christmas
import christmasIcon from '@/assets/events/christmas/icon.svg';
import christmasIconLight from '@/assets/events/christmas/icon-light.svg';
import christmasIconRounded from '@/assets/events/christmas/icon-rounded.svg';
import christmasIconRoundedPng from '@/assets/events/christmas/icon-rounded.png';
import christmasLogoFullSvg from '@/assets/events/christmas/logo-full.svg';
import christmasLogoFullPng from '@/assets/events/christmas/logo-full.png';
import christmasCapyTop from '@/assets/events/christmas/suifrens/capy-top.png';
import christmasCapyTopSurprised from '@/assets/events/christmas/suifrens/capy-top-surprised.png';
import christmasSideCapy from '@/assets/events/christmas/suifrens/side-capy.svg';
import christmasSideBullshark from '@/assets/events/christmas/suifrens/side-bullshark.svg';

import type { BullsharkAttributes } from '@suigar/suifrens-display-system';
import type { CapyAttributes } from '@suigar/suifrens-display-system';
import type { AccessoryMetadata } from '@suigar/suifrens-display-system';
import { accessories } from '@suigar/suifrens-display-system';

export type EventId = 'default' | 'saint-patrick' | 'valentines' | 'easter' | 'summer' | 'halloween' | 'christmas';

type MonthDay = { month: number; day: number };

type EventAssets = {
	logo: { light: string; dark: string };
	logoFull: { light: string; dark: string; svg: string };
	icon: { default: string; light: string };
	iconRounded: { svg: string; png: string };
	suifrenImages: {
		capyTop: string;
		capyTopSurprised: string;
		sideCapy: string;
		sideBullshark: string;
	};
};

type SuiFrenVariantConfig<TAttributes> = {
	attributes: TAttributes;
	accessories?: AccessoryMetadata[];
};

type EventSuifrenAppearance = {
	bullshark: SuiFrenVariantConfig<BullsharkAttributes>;
	capy: SuiFrenVariantConfig<CapyAttributes>;
};

const DEFAULT_BULLSHARK: BullsharkAttributes = {
	mainColor: 'ADC0F4',
	secondaryColor: 'FFF1D6',
	finStyle: 'classic',
	skin: 'basic',
	expression: 'happy',
};

const DEFAULT_CAPY: CapyAttributes = {
	mainColor: 'ADC0F4',
	secondaryColor: 'FFF1D6',
	earShape: 'default',
	skin: 'basic',
	expression: 'happy',
};

export interface EventThemeConfig {
	id: EventId;
	name: string;
	description: string;
	dateRange: { start: MonthDay; end: MonthDay };
	assets: EventAssets;
	suifren: EventSuifrenAppearance;
}

const defaultAssets: EventAssets = {
	logo: { light: suigarLogoMixedSvg, dark: suigarLogoMixedSvg },
	logoFull: { light: defaultLogoFullPng, dark: defaultLogoFullPng, svg: defaultLogoFullSvg },
	icon: { default: defaultIconSvg, light: defaultIconLightSvg },
	iconRounded: { svg: defaultIconRoundedSvg, png: defaultIconRoundedPng },
	suifrenImages: {
		capyTop: defaultCapyTop,
		capyTopSurprised: defaultCapyTopSurprised,
		sideCapy: defaultSideCapy,
		sideBullshark: defaultSideBullshark,
	},
};

function createDefaultAssets(): EventAssets {
	return {
		logo: { ...defaultAssets.logo },
		logoFull: { ...defaultAssets.logoFull },
		icon: { ...defaultAssets.icon },
		iconRounded: { ...defaultAssets.iconRounded },
		suifrenImages: { ...defaultAssets.suifrenImages },
	};
}

function createDefaultSuifren(): EventSuifrenAppearance {
	return {
		bullshark: { attributes: { ...DEFAULT_BULLSHARK }, accessories: [] },
		capy: { attributes: { ...DEFAULT_CAPY }, accessories: [] },
	};
}

function buildBullshark(overrides: Partial<BullsharkAttributes>): BullsharkAttributes {
	return { ...DEFAULT_BULLSHARK, ...overrides };
}

function buildCapy(overrides: Partial<CapyAttributes>): CapyAttributes {
	return { ...DEFAULT_CAPY, ...overrides };
}

function pickAccessories(...names: string[]): AccessoryMetadata[] {
	const needle = new Set(names.map((n) => n.toLowerCase().trim()).filter(Boolean));
	return accessories.filter((item) => needle.has(item.name.toLowerCase().trim()));
}

export const eventThemes: EventThemeConfig[] = [
	{
		id: 'saint-patrick',
		name: "Saint Patrick's Week",
		description: 'Lucky clovers, emerald hues, and golden accents.',
		dateRange: { start: { month: 3, day: 10 }, end: { month: 3, day: 24 } },
		assets: {
			logo: { light: spIconLight, dark: spIcon },
			logoFull: { light: spLogoFullPng, dark: spLogoFullPng, svg: spLogoFullSvg },
			icon: { default: spIcon, light: spIconLight },
			iconRounded: { svg: spIconRounded, png: spIconRoundedPng },
			suifrenImages: {
				capyTop: spCapyTop,
				capyTopSurprised: spCapyTopSurprised,
				sideCapy: spSideCapy,
				sideBullshark: spSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: '64BD45', secondaryColor: 'E0F2DA', expression: 'bigSmile' }),
				accessories: pickAccessories('bowler hat', 'stripe shirt'),
			},
			capy: {
				attributes: buildCapy({ mainColor: '64BD45', secondaryColor: 'E0FF86', earShape: 'wild', expression: 'bigSmile' }),
				accessories: pickAccessories('bowler hat', 'stripe shirt'),
			},
		},
	},
	{
		id: 'valentines',
		name: "Valentine's Season",
		description: 'Romantic reds, blush accents, and heart-inspired glow.',
		dateRange: { start: { month: 2, day: 1 }, end: { month: 2, day: 20 } },
		assets: {
			logo: { light: valIconLight, dark: valIcon },
			logoFull: { light: valLogoFullPng, dark: valLogoFullPng, svg: valLogoFullSvg },
			icon: { default: valIcon, light: valIconLight },
			iconRounded: { svg: valIconRounded, png: valIconRoundedPng },
			suifrenImages: {
				capyTop: valCapyTop,
				capyTopSurprised: valCapyTopSurprised,
				sideCapy: valSideCapy,
				sideBullshark: valSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: 'FF008A', secondaryColor: 'FEC0C2', expression: 'heartEyes' }),
				accessories: pickAccessories('hair bow', 'heart shirt'),
			},
			capy: {
				attributes: buildCapy({ mainColor: 'FF008A', secondaryColor: 'FEBFFF', earShape: 'mischievous', expression: 'heartEyes' }),
				accessories: pickAccessories('hair bow', 'heart shirt'),
			},
		},
	},
	{
		id: 'easter',
		name: 'Easter Celebration',
		description: 'Pastel palettes, spring bloom vibes, and playful energy.',
		dateRange: { start: { month: 3, day: 20 }, end: { month: 4, day: 20 } },
		assets: {
			logo: { light: easterIconLight, dark: easterIcon },
			logoFull: { light: easterLogoFullPng, dark: easterLogoFullPng, svg: easterLogoFullSvg },
			icon: { default: easterIcon, light: easterIconLight },
			iconRounded: { svg: easterIconRounded, png: easterIconRoundedPng },
			suifrenImages: {
				capyTop: easterCapyTop,
				capyTopSurprised: easterCapyTopSurprised,
				sideCapy: easterSideCapy,
				sideBullshark: easterSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: 'AEE0F5', secondaryColor: 'FCE370', expression: 'happy' }),
				accessories: pickAccessories('halo', 'stripe shirt'),
			},
			capy: {
				attributes: buildCapy({ mainColor: 'AEE0F5', secondaryColor: 'E0FF86', earShape: 'quiet', expression: 'happy' }),
				accessories: pickAccessories('halo', 'stripe shirt'),
			},
		},
	},
	{
		id: 'summer',
		name: 'Summer Splash',
		description: 'Golden sunsets, tropical seas, and a pool-party vibe.',
		dateRange: { start: { month: 6, day: 1 }, end: { month: 8, day: 31 } },
		assets: {
			logo: { light: summerIconLight, dark: summerIcon },
			logoFull: { light: summerLogoFullPng, dark: summerLogoFullPng, svg: summerLogoFullSvg },
			icon: { default: summerIcon, light: summerIconLight },
			iconRounded: { svg: summerIconRounded, png: summerIconRoundedPng },
			suifrenImages: {
				capyTop: summerCapyTop,
				capyTopSurprised: summerCapyTopSurprised,
				sideCapy: summerSideCapy,
				sideBullshark: summerSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: 'FF9519', secondaryColor: '4FCAC0', expression: 'cool' }),
				accessories: pickAccessories('baseball cap', 'lifeguard'),
			},
			capy: {
				attributes: buildCapy({ mainColor: 'FF9519', secondaryColor: 'AEE0F5', earShape: 'wild', expression: 'cool' }),
				accessories: pickAccessories('baseball cap', 'lifeguard'),
			},
		},
	},
	{
		id: 'halloween',
		name: 'Halloween Spree',
		description: 'Mystic purples, pumpkin oranges, and glow-in-the-dark moods.',
		dateRange: { start: { month: 10, day: 1 }, end: { month: 11, day: 2 } },
		assets: {
			logo: { light: halloweenIconLight, dark: halloweenIcon },
			logoFull: { light: halloweenLogoFullPng, dark: halloweenLogoFullPng, svg: halloweenLogoFullSvg },
			icon: { default: halloweenIcon, light: halloweenIconLight },
			iconRounded: { svg: halloweenIconRounded, png: halloweenIconRoundedPng },
			suifrenImages: {
				capyTop: halloweenCapyTop,
				capyTopSurprised: halloweenCapyTopSurprised,
				sideCapy: halloweenSideCapy,
				sideBullshark: halloweenSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: 'FF5C00', secondaryColor: '43426F', expression: 'mischievous', skin: 'stripes' }),
				accessories: pickAccessories('wizard hat', 'skull shirt', 'witch boots'),
			},
			capy: {
				attributes: buildCapy({ mainColor: 'FF5C00', secondaryColor: '43426F', earShape: 'mischievous', expression: 'goofy', skin: 'stripes' }),
				accessories: pickAccessories('wizard hat', 'skull shirt', 'witch boots'),
			},
		},
	},
	{
		id: 'christmas',
		name: 'Christmas & New Year',
		description: 'Evergreen forests, holly berries, and cozy winter nights.',
		dateRange: { start: { month: 12, day: 1 }, end: { month: 1, day: 5 } },
		assets: {
			logo: { light: christmasIconLight, dark: christmasIcon },
			logoFull: { light: christmasLogoFullPng, dark: christmasLogoFullPng, svg: christmasLogoFullSvg },
			icon: { default: christmasIcon, light: christmasIconLight },
			iconRounded: { svg: christmasIconRounded, png: christmasIconRoundedPng },
			suifrenImages: {
				capyTop: christmasCapyTop,
				capyTopSurprised: christmasCapyTopSurprised,
				sideCapy: christmasSideCapy,
				sideBullshark: christmasSideBullshark,
			},
		},
		suifren: {
			bullshark: {
				attributes: buildBullshark({ mainColor: '066011', secondaryColor: 'FCE370', expression: 'happy', skin: 'basic' }),
				accessories: pickAccessories('santa hat', 'stripe shirt', 'boots'),
			},
			capy: {
				attributes: buildCapy({ mainColor: '066011', secondaryColor: 'E0F2DA', earShape: 'default', expression: 'happy', skin: 'basic' }),
				accessories: pickAccessories('santa hat', 'stripe shirt', 'boots'),
			},
		},
	},
];

export const defaultEvent: EventThemeConfig = {
	id: 'default',
	name: 'Default',
	description: 'Standard Suigar look & feel.',
	dateRange: { start: { month: 1, day: 1 }, end: { month: 12, day: 31 } },
	assets: createDefaultAssets(),
	suifren: createDefaultSuifren(),
};

const allEvents = [defaultEvent, ...eventThemes];

const eventMap = allEvents.reduce<Record<EventId, EventThemeConfig>>(
	(acc, event) => {
		acc[event.id] = event;
		return acc;
	},
	{} as Record<EventId, EventThemeConfig>,
);

const dayValue = ({ month, day }: MonthDay) => month * 100 + day;

export function isDateWithinRange(date: Date, range: { start: MonthDay; end: MonthDay }) {
	const value = dayValue({ month: date.getMonth() + 1, day: date.getDate() });
	const start = dayValue(range.start);
	const end = dayValue(range.end);

	if (start <= end) {
		return value >= start && value <= end;
	}

	return value >= start || value <= end;
}

export function getActiveEvent(date: Date = new Date()): EventThemeConfig {
	for (const event of eventThemes) {
		if (isDateWithinRange(date, event.dateRange)) {
			return event;
		}
	}
	return defaultEvent;
}

export function getEventById(id: string | null | undefined): EventThemeConfig | null {
	if (!id) return null;
	return eventMap[id as EventId] ?? null;
}

export const selectableEvents = allEvents.map((event) => ({ id: event.id, name: event.name }));
